import React, { MouseEventHandler } from "react";
import { Box } from "../Box";
import { Icon } from "../Icon";

export const EventGalleryLeftNav = (
  onClick: MouseEventHandler<HTMLDivElement>
) => (
  <Box
    className={"image-gallery-icon image-gallery-left-nav"}
    onClick={onClick}
    cursor={"pointer"}
    bg={"white"}
    borderRadius={"circle"}
    width={"auto"}
    left={"10px"}
    p={0}
  >
    <Icon color={"neutral.500"} name={"chevron-left"} size={32} />
  </Box>
);
